import { UserData } from '@/types/types';

export function isLvPostPartner() {
  const userData: UserData = localStorage.user ? JSON.parse(localStorage.user) : {};

  return userData.consumerLoanApplicationAccess && userData.providesSigningService;
}
